export function validateRaspadinhaRegulation(): string | null {
  return null
}
